import React from 'react';
import './../App.css';
import ScrollAnimation from 'react-animate-on-scroll';
import ContactBitkala from '../Components/ContactBitkala';


export default class App extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.history.location.pathname);
  }

  state = {
    detailList: [],
    editId: -1
  }


  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  setDetailList(data) {

    this.setState(prevState => {
      return {
        detailList: data,
        editId: -1
      }
    })

  }

  editDetail(id) {
    this.setState(prevState => {
      return {
        editId: id
      }
    })
  }

  newEvent() {
    this.setState(prevState => {
      return {
        detailList: [{ Id: 0, Description: '', Tag: '' }],
        editId: 0
      }
    })

    console.log('رسsadadsadیدم');
    console.log(this.state);
    console.log(this.state.detailList);

  }

  render() {
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (

      <>
        <div class="header_section">
          <ScrollAnimation animateIn="fadeIn">
            <div>
              <div class="container">
                <div class="maz_fulltext">

                  <h1>تولید یک موبایل اپلیکیشن حرفه ای</h1>
                  <p>در دنیایی که با اپلیکیشن های مختلف احاطه شده؛&nbsp;ساخت اپلیکیشن حرفه ای&nbsp;به دغدغه ای تازه برای کارشناسان حوزه ی دیجیتال،&nbsp;تبدیل شده است. بسیاری از شرکت های توسعه دهنده ی این اپلیکیشن ها ممکن است در سال حتی بیش از بیست تا سی اپلیکیشن نیز به بازار عرضه کنند. اکثر گجت هایی هم که امروزه تولید می شوند باید با یک اپلیکیشن کنترل شوند. از انواع درون ها گرفته تا بسیاری از لوازم خانگی جدید تنها از طریق یک اپلیکیشن بر روی گوشی هوشمند قابل کنترل هستند.</p>
                  <p>اصولا اپلیکیشن ها تاثیر بسیار زیادی بر روی کسب و کارهای مختلف و زمینه های گوناگون زندگی هریک از ما داشته اند. گوشی های هوشمند براحتی در دسترس کاربران می باشند. اصولا اپلیکیشن های موبایل باعث تعامل هرچه بیشتر میان خدمات دهندگان و مخاطبان آنان می شود. به عنوان مثال امروزه برای درخواست تاکسی طراحی اپلیکیشن تاکسی یاب ،برای خرید کالا طراحی اپلیکیشن فروشگاهی و برای انجام امور اداری و خدمات رسانی طراحی اپلیکشین شرکتی می تواند مورد استفاده قرار گیرد.</p>
                  <p>&nbsp;</p>
                  <p>طراحی اپلیکیشن حرفه ای باعث خواهد شد که شما براحتی با مخاطبین خود در ارتباط باشید. در اینجا می بایست به تاثیر اعلان هایی که اپلیکیشن ها برای کاربر موبایل های هوشمند ارسال می کنند را یادآوری نماییم. ارسال یک پیام باعث حفظ ارتباط با مشتری می شود و به او یادآوری می کند که شما همیشه در دسترس هستید که خود از نظر روانشناسی تاثیر بسیار زیادی بر روی کاربران خواهد داشت.</p>
                  <p>&nbsp;</p>
                  <p>تولید کننده اپلیکشن باید یک سری نکات کلیدی را در تولید نرم افزار رعایت کند تا در نهایت یک اپلیکیشن حرفه ای دست مشتری برسد که کابران نهایی به راحتی از آن استفاده کنند و بتوانند با محیط نرم افزار &nbsp;ارتباط برقرار کنند و سرعت لود بالا داشته باشد و بعدا با هزینه زمانی و مالی کمتر بتوان آن را گسترش داد و امکانات جدیدی به آن اضافه نمود.باید کد نویسی آن بر اساس آخرین تکنولوژی های و متد های نرم افزاری ایجاد شده باشد که بعدا نرم افزار دچار باگ های متعدد نگردد.</p>
                  <p>تیم بیت کالا از ابتدای راه تولید نرم افزار با شما خواهد بود و ابتدا با مشاوره رایگان مسیر راهتان را مشخص خواهد کرد و بعد از تولید نرم افزار با پشتیبانی خوب و کامل و رفع باگ های موجود در نرم افزار و افزودن ماژول های مورد نیاز در آینده در مسیر رشد نرم افزار در کنار شما خواهد بود.آنچه در ذهن دارید را با ما درمیان بگذارید تا متخصصان ما آن را در غالب نرم افزار &nbsp;پیاده سازی نمایند.</p>
                  <p>&nbsp;</p>

                  <h1>مراحلی که در بیت کالا برای تولید اپلیکیشن حرفه ای شما پیموده می شود:</h1>
                  <p><strong>گام۱: تخیل عالی و کامل در مورد نرم افزاری که شما نیاز دارید</strong></p>
                  <p>اولین چیزی که باید بررسی شود این است که:</p>
                  <p>- &nbsp;&nbsp;&nbsp;مشکلی را که توسط اپ شما می‌تواند حل شود، شناسایی شود</p>
                  <p>- &nbsp;&nbsp;&nbsp;درباره قابلیت‌های اپ‌تان تصمیم گیری شود</p>
                  <p>اپ باید برای مشتری فوایدی ملموس داشته باشد، از جمله کاهش هزینه‌ها از طریق افزایش بازدهی، عایدی تازه و یا بهبود تجربه کاربری.</p>
                  <p>&nbsp;</p>
                  <p><strong>گام ۲: شناسایی مولفه ها:</strong></p>
                  <p>برای ساخت یک اپ موفق باید:</p>
                  <h3>کاربران هدف اپلیکیشن مشخص می شوند.</h3>
                  <p>یک اپ همواره باید با در نظر داشتن کاربران هدف آن توسعه داده شود. داشتن دیدی روشن از گروه هدف، نرخ موفقیت اپ را افزایش می‌دهد.</p>
                  <h3>پلتفرم‌های موبایل و دستگاه‌هایی را که قرار است پشتیبانی شود شناسایی می شوند.</h3>
                  <p>پلتفرم‌های موبایل و دستگاه‌ها باید با در نظر گرفتن عملکرد سخت‌افزاری، عمر باتری، بنیه و لوازم جانبی مورد نیاز انتخاب شوند. عامل‌های خاصی که باید هنگام انتخاب پلتفرم‌های موبایل در نظر گرفته شود شامل پوشش دهی، پشتیبانی از دستگاه‌ها، عملکرد و دیگر قابلیت‌هاست.</p>
                  <h3>مدل سود شناسایی می شود.</h3>
                  <p>بازار اپ هرگز به این اندازه شلوغ نبوده است. برای آنکه از این منبع مطمئن شوید و تولید سود کنید، لازم است که توسعه دهنده اپ رویکرد مناسبی را هماهنگ با اپ برگزیند. مدل‌های متفاوتی از تولید سود از جانب اپ‌های موبایل وجود دارد که شامل اپلیکیشن‌های پولی، رایگان‌پایه(فری‌میوم)های اپ جداگانه و درون‌برنامه‌ای، تبلیغات، اشتراک و حق دانلود است.</p>
                  <p>&nbsp;</p>
                  <p><strong>گام ۳: اپ شما طراحی می شود.</strong></p>
                  <p>&nbsp;طراحی اپ‌تان نیز از عواملی مهمی است که در موفقیت اپ در بازار نقش دارد. یک توسعه دهنده اپ باید بر روی طراحی واسط کاربری و قابلیت‌های چند-لمسی برای دستگاه‌های لمسی تمرکز کند و استانداردهای طراحی پلتفرم را نیز در نظر بگیرد. امروزه تاکید بر روی طراحی واسط کاربری ست چرا که نقشی حیاتی را در موفقیت اپ بازی می‌کند. طراحی اپ روز به روز محبوب‌تر می‌شود چون تاثیری آنی بر ذهن کاربر می‌گذارد و در عین حال قابلیت استفاده از اپ را نیز تضمین می‌کند.</p>
                  <p>&nbsp;</p>
                  <p><strong>گام ۴: یک نمونه اولیه تولید می شود</strong></p>
                  <p>مرحله بعدی پس از شناسایی رویکرد، توسعه‌ی یک نمونه اولیه است. این کار در واقع فرآیند گرفتن یک ایده و تبدیل آن به اپلیکیشنی با قابلیت‌هایی پایه‌ای است.</p>
                  <p>&nbsp;</p>
                  <p>&nbsp;</p>
                  <p><strong>گام ۵: اپ &nbsp;منتشر می شود.</strong></p>
                  <p>به کار گیری یک اپ نیاز به طرح، برنامه و کنترل حرکت انتشار برای محیط‌های آزمایشی و واقعی دارد.&nbsp;</p>
                  <p>&nbsp;</p>
                  <p><strong>گام۶: نظارت بر معیارهای سنجش</strong></p>
                  <p>در دهه اخیر در تعداد کاربران اپ موبایل افزایش شدیدی را شاهد بوده‌ایم. در نتیجه، نیاز به گردآوری معیارهای دقیق بسیار مهم است. همچنان که تعداد مصرف‌کنندگانی که از اپلیکیشن‌های موبایل استفاده می‌کنند بطور یکنواخت زیاد می‌شود، نیاز به گردآوری معیار برای آنها نیز افزایش می‌یابد.</p>
                  <p>معیارهای ورودی مهمی که باید به یاد داشت:</p>
                  <h3>تحلیل قیف (Funnel) نشان می‌دهد که چرا کاربران در تکمیل اعمال کاربری خود مثل خرید‌های درون‌برنامه‌ای و یا کلیک‌های تبلیغاتی ناکام می‌مانند،</h3>
                  <h3>سنجش اشتراک‌گذاری اجتماعی نشان می‌دهد چه جنبه‌هایی از اپ شما توجه کاربران را به خود جلب کرده است،</h3>
                  <h3>ارتباط دهی داده‌های جمعیت‌شناسی با رفتار کاربر،</h3>
                  <h3>&nbsp;دنبال کردن زمان و مکان به شما درباره محیطی که اپ‌تان در آن استفاده می‌شود، آگاهی می‌دهد،</h3>
                  <h3>و نهایتا، زیر نظر گرفتن رفتارهای ظاهر شده‌ی پایگاه کاربری‌تان مساله مهمی است</h3>
                  <p>&nbsp;</p>
                  <p><strong>گام ۷:ارتقاء اپ شما با اصلاحات و قابلیتهای جدید</strong></p>
                  <p>باید اپ شما &nbsp;بروز نگه داشته شود و قابلیت های جدید به آن اضافه شود تا برای مشترکین شما جذاب بماند.</p>

                </div>
              </div>

              <ContactBitkala></ContactBitkala>
              <div class="container">
                <div class="maz_fulltext">


                  <h2>سوالات متداول:</h2>
                  <p><strong>برای داشتن موبایل اپلیکیشن حرفه ای چه کاری باید انجام دهیم ؟</strong></p>
                  <p>ابتدا باید مشخص کنید که این اپلیکیشن چه وظیفه ای را به عهده خواهد داشت و ورودیها و خروجی های نرم افزار را روی کاغذ مشخص کنید.</p>
                  <p><strong>تکنولوژی های مورد استفاده بیت کالا برای تهیه موبایل اپلیکیشن چه می باشد ؟</strong></p>
                  <p>با توجه به نوع پروژه ، انتخاب تکنولوژی متفاوت است.</p>
                  <p>اگر اپلیکیشن نیاز به ذخیره داده ها و سرویس گیری از سرور اصلی داشته باشد یک بخش API مورد نیاز است که باید طراحی و تولید شود و در سرور اصلی در شرکت خودتان یا شرکتهای ارائه خدمات سرور پابلیش می شود.</p>
                  <p>اپلیکیشنی که در گوشی اندروید یا ios نصب می شود با تکنولوژی React Native توسط تیم بیت کالا تولید می شود.</p>
                  <p>آیا قابلیت ارائه سورس کد های برنامه وجود دارد ؟</p>
                  <p>بله . هزینه ارائه سورس برنامه نسبت به نوع پروژه ها متفاوت می باشد.</p>
                  <p><strong>ما یک شرکت کوچک هستیم. حداقل هزینه طراحی موبایل اپلیکیشن چقدر است ؟</strong></p>
                  <p>پایین ترین هزینه برای راه اندازی یک&nbsp;اپلیکیشن موبایل&nbsp;۸ میلیون تومان می باشد.</p>
                  <p><strong>پشتیبانی رایگان شما بعد از تحویل پروژه چند ماه می باشد ؟</strong></p>
                  <p>سه ماه</p>
                  <p><strong>آیا آموزش پنل کاربری موبایل اپلیکیشن بعد از تحویل پروژه رایگان است ؟</strong></p>
                  <p>بله. ارائه یک مرتبه آموزش کامل همراه با فیلم آموزشی به نماینده کارفرما رایگان می باشد.</p>
                </div>
              </div>
            </div>
          </ScrollAnimation>
        </div>


      </>
    )
  }
}


